import { LogLevel } from '@azure/msal-browser'

interface ADConfigTypes {
  AD_AUTHORITY: string
  AD_CACHE_LOCATION: string
  AD_CLIENT_ID: string
  AD_REDIRECT_URI: string
  AD_SCOPE: string
  AD_STORE_AUTHSTATE_IN_COOKIE: boolean
}

// AD variables are not considered a secret so it's okay to have here
const configInfo: ADConfigTypes = {
  AD_SCOPE: window.appConfig.AD_SCOPE,
  AD_CLIENT_ID: window.appConfig.AD_CLIENT_ID,
  AD_AUTHORITY: window.appConfig.AD_AUTHORITY,
  AD_REDIRECT_URI: window.appConfig.REDIRECT_URI,
  AD_CACHE_LOCATION: window.appConfig.AD_CACHE_LOCATION || 'localStorage',
  AD_STORE_AUTHSTATE_IN_COOKIE: true,
}

export const msalConfig = {
  auth: {
    clientId: configInfo.AD_CLIENT_ID,
    authority: configInfo.AD_AUTHORITY,
    redirectUri: configInfo.AD_REDIRECT_URI,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: configInfo.AD_CACHE_LOCATION,

    // Set this to "true" if you are having issues on IE11 or Edge
    storeAuthStateInCookie: configInfo.AD_STORE_AUTHSTATE_IN_COOKIE,
  },
  system: {
    loggerOptions: {
      loggerCallback: (
        level: LogLevel,
        message: string,
        containsPii: boolean
      ) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            // eslint-disable-next-line no-console
            console.error({ message })

            return
          case LogLevel.Warning:
            // eslint-disable-next-line no-console
            console.warn({ message })
            break
          default:
        }
      },
      piiLoggingEnabled: false,
    },
  },
}

const requestConfig = { scopes: [configInfo.AD_SCOPE] }

export const loginRequestConfig = {
  prompt: 'login',
  ...requestConfig,
}
